// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25vgO","colMin":"styles_colMin__34ya5"};